const students = state => state.students;

export default {
    students,
};



// WEBPACK FOOTER //
// ./src/taskflex/students/store/students/_actions.js